"use client";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import Filters from "./Filters";
import ProductCard from "@/app/views/popular/components/ProductCard";
import { useSearchParams } from "next/navigation";
import { Badge } from "@/components/ui/badge";
import { LibraryBig } from "lucide-react";
import CustomPagination from "@/custom/CustomPagination";
import CustomBreadcrumbs from "@/custom/CustomBreadcrumbs";

const Products = ({
  products,
  total,
  count,
  range,
  authors,
  categories,
  publishers,
  brands,
}) => {
  const searchParams = useSearchParams();
  const sort = searchParams.get("sort");
  const author = searchParams.get("author");
  const category = searchParams.get("category");
  const language = searchParams.get("language");
  const publisher = searchParams.get("publisher");
  const price = searchParams.get("price");
  const rating = searchParams.get("rating");

  return (
    <div className="container mx-auto my-10">
      <div className="space-y-10">
        <CustomBreadcrumbs text="Todays Deal" />
        <div className="flex flex-col lg:flex-row items-start gap-4">
          <Filters
            authors={authors}
            categories={categories}
            publishers={publishers}
            brands={brands}
          />
          <Card className="flex flex-col gap-4 w-full">
            <CardHeader className="bg-custom-slider-bg-gray  ">
              <div className="flex flex-wrap h-fit items-center gap-2 text-sm">
                <p className="text-base text-custom-black  font-medium">
                  {range}
                </p>
                {sort && (
                  <Badge variant="outline" className="capitalize">
                    sort: {sort}
                  </Badge>
                )}
                {author && (
                  <Badge variant="outline" className="capitalize">
                    author: {author}
                  </Badge>
                )}
                {category && (
                  <Badge variant="outline" className="capitalize">
                    category: {category}
                  </Badge>
                )}
                {publisher && (
                  <Badge variant="outline" className="capitalize">
                    publisher: {publisher}
                  </Badge>
                )}
                {language && (
                  <Badge variant="outline" className="capitalize">
                    language: {language}
                  </Badge>
                )}
                {price && (
                  <Badge variant="outline" className="capitalize">
                    price: {price}
                  </Badge>
                )}
                {rating && (
                  <Badge variant="outline" className="capitalize">
                    rating: {rating}
                  </Badge>
                )}
              </div>
            </CardHeader>
            <CardContent className="flex flex-wrap gap-4 p-3 sm:p-6">
              {products?.length === 0 ? (
                <Card>
                  <CardHeader>
                    <CardTitle className="text-xl font-medium">
                      <LibraryBig strokeWidth={1} size={45} />
                      <p>No Products Found</p>
                    </CardTitle>
                    <CardDescription className="text-custom-black ">
                      We couldn&apos;t find any products matching your criteria.
                      Please adjust your search or reset filters. For
                      assistance, contact our support. Thank you.
                    </CardDescription>
                  </CardHeader>
                </Card>
              ) : (
                <div className="grid  grid-cols-2 md:grid-cols-3  lg:grid-cols-4 gap-3 sm:gap-4">
                  {products?.map((book, i) => (
                    <div className="w-full  relative overflow-hidden" key={i}>
                      <ProductCard product={book} />
                    </div>
                  ))}
                </div>
              )}
            </CardContent>
          </Card>
        </div>
        <CustomPagination total={total} count={count} />
      </div>
    </div>
  );
};

export default Products;
